import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.styl';

const gray = '#D3D3D3';

const StarIcon = ({ fill, width = 24, height = 24, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z'
        fill={fill}
      />
    </svg>);
};

const Star = ({ type, starWidth, starHeight, color }) => {
  if (type === 'half') {
    return (
      <>
        <StarIcon fill={gray} width={starWidth}
          height={starHeight} className={styles.star}
        />
        <StarIcon
          fill={color}
          width={starWidth}
          height={starHeight}
          className={styles.starHalf}
        />
      </>
    );
  }

  return (
    <StarIcon
      fill={type === 'full' ? color : gray}
      width={starWidth}
      height={starHeight}
      className={styles.star}
    />
  );
};

StarIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
};

Star.propTypes = {
  type: PropTypes.oneOf(['full', 'half', 'empty']).isRequired,
  starWidth: PropTypes.number,
  starHeight: PropTypes.number,
  color: PropTypes.string,
};

Star.defaultProps = {
  starWidth: 24,
  starHeight: 24,
};

export default Star;
